module.exports = new Promise(resolve => {
          let remoteUrl = window._env_.APP_DCP_CONSOLE_URL + "/mfs/alerts-ui/remoteEntry.js"
          if (false){
            remoteUrl = "http://localhost:2000/remoteEntry.js"
            // remoteUrl = "https://console.druva.com/mfs/alerts-ui/remoteEntry.js"
          }
          const script = document.createElement('script')
          script.src = remoteUrl
          script.onload = () => {
            // the injected script has loaded and is available on window
            // we can now resolve this Promise
            const proxy = {
              get: (request) => window.dcp_alerts.get(request),
              init: (arg) => {
                try {
                  return window.dcp_alerts.init(arg)
                } catch(e) {
                  console.log('remote container already initialized')
                }
              }
            }
            resolve(proxy)
          }
          script.onerror = (error) => {
            console.error('Error loading dcp_alerts remote container', error);
            const proxy = {
              get: () => {
                // Reject so React.lazy fails into WrapErrorAndSuspense
                // (alerts page shows the error boundary; AlertsProvider falls back to children).
                return Promise.reject(
                  new Error('Failed to resolve dcp_alerts remote container'),
                );
              },
              init: () => {
                return;
              }
            }
            resolve(proxy)
          }
          // inject this script with the src set to the versioned remoteEntry.js
          document.head.appendChild(script);
        })
        ;